import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { ShimanoPaginationModule } from '../../pagination/pagination.module';
import { SortingModule } from '../../sorting/sorting.module';
import { TableModule } from '../../table/table.module';
import { EmployeeAddListsComponent } from './employee-add-lists/employee-add-lists.component';
import { EmployeeStatusListsComponent } from './employee-status-lists/employee-status-lists.component';
import { MyaccountEmployeeListsComponent } from './myaccount-employee-lists.component';

@NgModule({
  declarations: [MyaccountEmployeeListsComponent, EmployeeStatusListsComponent, EmployeeAddListsComponent],
  imports: [
    CommonModule,
    I18nModule,
    SortingModule,
    TableModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    ShimanoPaginationModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountManageEmployeeComponent: {
          component: MyaccountEmployeeListsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
  exports: [MyaccountEmployeeListsComponent],
})
export class MyaccountEmployeeListsModule {}
